export const DO_LOGOUT = 'DO_LOGOUT'

export const SET_USU_EMAIL = 'SET_USU_EMAIL'
export const SET_USU_PHONE = 'SET_USU_PHONE'
export const SET_USER = 'SET_USER'
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS'
